import { render, staticRenderFns } from "./SectionContact.vue?vue&type=template&id=6d9d3506&scoped=true"
import script from "./SectionContact.vue?vue&type=script&lang=js"
export * from "./SectionContact.vue?vue&type=script&lang=js"
import style0 from "./SectionContact.vue?vue&type=style&index=0&id=6d9d3506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d3506",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactForm: require('/builds/marketing/abstracta.academy-website/components/ContactForm.vue').default})
